<template>
  <v-dialog v-model="getImageViewer.show" width="60%" persistent>
    <v-card width="100%">
      <v-card-title class="pa-4" style="overflow: visible">
        <v-row align="center" no-gutters class="w-100">
          <v-col cols="1"></v-col>

          <v-col
            cols="10"
            class="d-flex justify-center align-center text-center"
          >
            <span class="text-h4 font-weight-bold">
              {{ getImageViewer.name }} - {{ getImageViewer.floor }}
            </span>
          </v-col>

          <v-col cols="1" class="pa-0 d-flex justify-center align-center">
            <div
              class="d-flex flex-column align-center"
              @click="closeImageViewer()"
              style="cursor: pointer"
            >
              <v-progress-circular
                :rotate="180"
                :size="50"
                :width="7"
                :value="closePercentage"
                color="error"
                class="mb-1"
              >
                <v-icon large color="error"> mdi-close </v-icon>
              </v-progress-circular>

              <span
                class="error--text font-weight-medium text-uppercase text-caption"
              >
                Close
              </span>
            </div>
          </v-col>
        </v-row>
      </v-card-title>

      <v-divider class="mx-2"></v-divider>

      <v-row no-gutters>
        <v-col cols="12" class="mb-10">
          <v-img :src="getImageViewer.url" width="98%"></v-img>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "imageViewer",
  data() {
    return {
      closePercentage: 0,
      timeout: 0,
      intervalObj: 0,
    };
  },
  computed: {
    ...mapGetters(["getImageViewer", "getIsSpeaking"]),
  },
  watch: {
    getIsSpeaking(newVal) {
      if (this.getImageViewer.show) {
        if (!newVal) {
          clearTimeout(this.timeout);
          this.intervalObj = setInterval(() => {
            this.closePercentage += 2;
            if (this.closePercentage === 100) {
              this.$store.commit("closeImageViewer");
              clearInterval(this.intervalObj);
              this.closePercentage = 0;
            }
          }, 250);
        } else {
          this.closePercentage = 0;
          clearInterval(this.intervalObj);
          clearTimeout(this.timeout);
        }
      }
    },
  },
  methods: {
    closeImageViewer() {
      this.closePercentage = 0;
      clearInterval(this.intervalObj);
      this.$store.commit("closeImageViewer");
    },
  },
  mounted() {
    console.log("Image Viewer info: ", this.getImageViewer);
  },
};
</script>

<style scoped></style>
